import React from 'react'
import PersonIcon from '@material-ui/icons/Person'
import Typography from '@material-ui/core/Typography'
import { FlexDataItem } from 'components/FlexDataView'

export default props =>
  <FlexDataItem>
    <Typography variant='subtitle1'><PersonIcon />Investor</Typography>
    <dl>
      <dt>Name</dt>
      <dd>{props.allocation.investorAccount.accountName}</dd>
      {props.allocation.bankReference && (
        <>
          <dt>Payment Reference</dt>
          <dd>{props.allocation.bankReference}</dd>
        </>
      )}
      {props.allocation.tokenDestinationAddress && (
        <>
          <dt>Destination ERC20 Address</dt>
          <dd>{props.allocation.tokenDestinationAddress}</dd>
        </>
      )}
    </dl>
  </FlexDataItem>